import { render, staticRenderFns } from "./ModalPromptPay.vue?vue&type=template&id=2de69536"
import script from "./ModalPromptPay.vue?vue&type=script&lang=js"
export * from "./ModalPromptPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports